import React, {Suspense, useState, useEffect } from 'react';
import { cyan } from '@material-ui/core/colors';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';


import Amplify, { Auth } from 'aws-amplify';

import Home from './Containers/Home'
import Login from './Containers/Login'

Amplify.configure({
    Auth: {
        region: 'eu-west-1', 
        userPoolId: process.env.USER_POOL_ID || 'eu-west-1_jOcvlQ6Wt', 
        userPoolWebClientId: process.env.WEB_CLIENT_ID || '6r4jqo7sfk6c5ivtuu35v927m9',
    },
    API: {
        endpoints: [
            {
                name: "CrystalusionAPI",
                endpoint: process.env.API_URL || "https://qgkrwc4b4e.execute-api.eu-west-1.amazonaws.com/production",
                custom_header: async () => {
                  return { Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
                },
            },
        ]
    }
});
Auth.configure({authenticationFlowType: 'CUSTOM_AUTH'});

const darkTheme = createMuiTheme({
  palette: {
    // Switching the dark mode on is a single property value change.
    type: 'dark',
    primary: cyan,
  },
});

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    async function getCurrentUser(){
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUser(user.attributes);
        setIsAuthenticated(true);
      } catch(err) {
        console.log(err)
      }
    };

    getCurrentUser();
  }, []);

  const handleAuthorisation = (user) => {
    setUser(user !== undefined ? user : undefined);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    Auth.signOut();
    setIsAuthenticated(false);
    setUser(undefined);
  };

  return (
    <Suspense fallback="">
      <ThemeProvider theme={darkTheme}>
      {isAuthenticated ? 
        <Home user={user} handleLogout={handleLogout}/>
      :
        <Login handleAuthorisation={handleAuthorisation} user={user}/>
      }
      </ThemeProvider>
    </Suspense>
  )
}
